import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import {
  MiBox,
  MiButton,
  MiCheckbox,
  MiDetailPageHeader,
  MiList,
  MiMenu,
} from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { capitalize } from "@miplatform/utils";
import { mdiChevronLeft, mdiPencilOutline, mdiPlus } from "@mdi/js";
import { Box } from "@mui/material";
import { ContactRelationshipDrawer } from "./ContactRelationshipDrawer/ContactRelationshipDrawer";
import { useContactRelationshipListViewModel } from "./useContactRelationshipListViewModel";

export function ContactRelationshipList() {
  const { classes } = useStyles();
  const { dependentType } = useParams();
  const [showDrawer, setShowDrawer] = useState(false);
  const [currentEditItem, setCurrentEditItem] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const {
    relationships,
    isLoading,
    loadData,
    createRelationship,
    deleteRelationship,
  } = useContactRelationshipListViewModel({ dependentType });

  useEffect(() => {
    if (dependentType) {
      loadData();
    }
  }, [dependentType]);

  const sections = [
    {
      fieldset: [
        {
          label: "Relationship",
          field: "label",
        },
        {
          label: "Active",
          field: "isActive",
          value: "show",
          renderValue: (row) => {
            return (
              <MiCheckbox
                value={row.isActive}
                handleChange={(e) => {
                  if (e.target.checked) {
                    createRelationship(row);
                    return;
                  }
                  deleteRelationship(row);
                }}
              />
            );
          },
        },
      ],
    },
  ];

  const renderHeaderActions = () => {
    return (
      <Box flex={1} display="flex" justifyContent="flex-end">
        <MiButton
          data-testid="create-new-relationship-button"
          variant={BUTTON_VARIANTS.CONTAINED}
          title="Create New Relationship"
          startIcon={{ path: mdiPlus }}
          onClick={() => setShowDrawer(true)}
        />
      </Box>
    );
  };

  const renderCardActions = (item) => (
    <Box
      className={classes.actionContainer}
      onClick={(e) => e.stopPropagation()}
    >
      <MiMenu
        disabled={!item.isActive}
        data={[
          {
            label: "Edit",
            icon: item.isActive ? mdiPencilOutline : null,
            action: () => {
              setCurrentEditItem(item);
              setEditMode(true);
              setShowDrawer(true);
            },
          },
        ]}
      />
    </Box>
  );

  const closeDrawer = () => {
    setShowDrawer(false);
    setCurrentEditItem(null);
    setEditMode(false);
  };

  return (
    <div className={classes.contentContainer}>
      <MiDetailPageHeader
        title={`${capitalize(dependentType)} Relationships`}
        titleIcon={mdiChevronLeft}
        loading={isLoading}
        actionComponent={renderHeaderActions()}
      />
      <MiBox>
        <MiList
          viewType="card"
          cardProps={{
            sections,
            leftCardProps: { fieldset: [] },
            renderItemActions: renderCardActions,
          }}
          data={relationships}
          loading={isLoading}
          hideListPagination
        />
      </MiBox>
      <ContactRelationshipDrawer
        open={showDrawer}
        editMode={editMode}
        dependentType={dependentType}
        relationship={currentEditItem}
        onClose={closeDrawer}
        onSave={() => {
          closeDrawer();
          loadData();
        }}
      />
    </div>
  );
}

const useStyles = makeStyles()(() => ({
  contentContainer: {
    display: "flex",
    flex: 1,
    overflow: "hidden",
    flexDirection: "column",
    width: "100%",
  },
}));
